import React from "react";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";

export const SearchArea: React.FC<{
  currentQuery: string;
  setCurrentQuery: React.Dispatch<React.SetStateAction<string>>;
  onClick: () => void;
}> = ({ currentQuery, setCurrentQuery, onClick }) => {
  return (
    <section className="search-area">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onClick();
        }}
      >
        <TextField
          value={currentQuery}
          onChange={async (event) => {
            setCurrentQuery(event.target.value);
          }}
          id="outlined-basic"
          label="Search"
          variant="outlined"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={(event) => {
                    onClick();
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <div style={{ display: "flex", justifyContent: "flex-end " }}>
          <img
            alt="search by Algolia"
            src="https://res.cloudinary.com/hilnmyskv/image/upload/q_auto/v1601475673/Algolia_com_Website_assets/images/shared/algolia_logo/search-by-algolia-light-background.svg"
            style={{ width: "120px", marginTop: "8px" }}
          />
        </div>
      </form>
    </section>
  );
};
